import React, { useState } from "react";
import { IPage } from "../../../../interfaces/models/models/paginated-response.model";
import { IPaginationPayload } from "../../../../interfaces/shared/IPaginationPayload";
import Table from "../../../../shared/table";
import moment from "moment";
import { onFormatPurchaseStatus } from "../../../../utils/constants/purchase-statuses";
// import { useAcceptOrRejectDraftMutation } from "../../../../store/reservations/reservationsApi";
import { IDraftResponse } from "../../../../interfaces/reservations/IDraftResponse";
import { IToast } from "../../../../interfaces/components/IToast";
import Toast from "../../../../shared/toast";

const tableColumns = [
//   "Actions",
  "Draft Id",
  "Email",
  "Status",
  "Type",
  "Reservation Information",
  "Created At",
];

interface IDraftsRequestTable {
  rows: IDraftResponse[];
  paginationData?: IPage;
  rowsLoading: boolean;
  setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const DraftsRequestTable = ({
  rows,
  paginationData,
  rowsLoading,
  setPaginationState,
}: IDraftsRequestTable) => {
  const [showToast, setShowToast] = useState<IToast | null>();
//   const [acceptOrRejectDraft] = useAcceptOrRejectDraftMutation();
//   const [, setShowReject] = useState<{
//     show: boolean;
//     id: string;
//   }>();

//   const handleAcceptOrReject = async (
//     id: string,
//     emailId: string,
//     response: "accept" | "reject"
//   ) => {
//     try {
//       await acceptOrRejectDraft({
//         id,
//         emailId,
//         response,
//       }).unwrap();
//       setShowToast({
//         type: "success",
//         message: "This draft has been accepted",
//       });
//     } catch (e) {
//       setShowToast({ type: "error", message: "Cannot save this draft" });
//     }
//   };
//   const handleReject = (id: string) => {
//     setShowReject({
//       show: true,
//       id,
//     });
//   };
//   const toggleReject = () => setShowReject({ show: false, id: "" });
  return (
    <Table
      columns={tableColumns}
      paginationData={paginationData}
      setPaginationState={setPaginationState}
    >
      {rowsLoading ? (
        <>
          {[...Array(4)].map((x, i) => {
            return (
              <tr key={i}>
                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                  return (
                    <td key={j} className="td-1 !min-w-[100%] text-center py-5">
                      <span></span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </>
      ) : (
        <>
          {rows?.length > 0 &&
            rows?.map(row => {
              const {
                text,
                color,
                name: value,
              } = onFormatPurchaseStatus(row.status);
              const itemFormat = color && (
                <div
                  className={`${color} border flex flex-row justify-center text-center px-1 min-w-[100px] ${text} text-sm py-1 font-medium !rounded-md`}
                >
                  {value}
                </div>
              );
              return (
                <tr key={row._id} className="bg-white border-b hover:bg-gray-50">
                  {/* <td className="px-6 py-4">
                    {row.status === "pending" && (
                      <>
                        <Button
                          loading={isLoading}
                          className="mx-2 my-1 btn-primary-rounded"
                          onClickButton={() =>
                            handleAcceptOrReject(row._id, row.emailId, "accept")
                          }
                          label="Accept"
                        />
                        <Button
                          className="mx-2 my-1 btn-error rounded-2xl"
                          onClickButton={() => handleReject(row._id)}
                          label="Reject"
                        />

                        <RejectDraftDialog
                          openModal={
                            !!showReject?.show && showReject.id === row._id
                          }
                          draftId={row._id}
                          emailId={row.emailId}
                          handleCloseModal={toggleReject}
                        />
                      </>
                    )}
                  </td> */}
                  <td className="px-6 py-4">
                    <div className="w-20 break-words">{row?._id}</div>
                  </td>
                  <td className="px-5 py-4">
                    <div className="w-28 break-words">{row?.email}</div>
                  </td>
                  <td className="px-6 py-4">{itemFormat}</td>
                  <td className="px-6 py-4">{row?.type}</td>
                  <td className="px-5 py-4">
                    {row.reservationDetails && (
                      <>
                        <b>Starting Date</b>:{" "}
                        {moment(row.reservationDetails?.startingDate).format(
                          "DD/MM/YYYY"
                        )}{" "}
                        <br />
                        <b>Ending Date</b>:{" "}
                        {moment(row.reservationDetails?.endingDate).format(
                          "DD/MM/YYYY"
                        )}{" "}
                        <br />
                        {row.reservationDetails.numberOfPersons && (
                          <>
                            <b>Number of persons</b>:{" "}
                            {row.reservationDetails.numberOfPersons}
                          </>
                        )}
                      </>
                    )}
                  </td>

                  <td className="px-5 py-4">
                    {moment(row?.updatedAt).format("DD/MM/YYYY HH:mm")}
                  </td>
                </tr>
              );
            })}
          {showToast?.message && (
            <Toast
              type={showToast?.type}
              text={showToast?.message}
              onHandleCloseToast={() => setShowToast(null)}
            />
          )}
        </>
      )}
    </Table>
  );
};

export default DraftsRequestTable;
